import { baseApi as api } from "./baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCategoryGetListById: build.query<
      GetCategoryGetListByIdApiResponse,
      GetCategoryGetListByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Category/GetList/${queryArg.id}`,
        headers: {
          "X-localization": queryArg["X-localization"],
          authorization: queryArg.authorization,
        },
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    getCategoryGetList: build.query<
      GetCategoryGetListApiResponse,
      GetCategoryGetListApiArg
    >({
      query: (queryArg) => ({
        url: `/Category/GetList`,
        headers: {
          "X-localization": queryArg["X-localization"],
          authorization: queryArg.authorization,
        },
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    postCategoryAdd: build.mutation<
      PostCategoryAddApiResponse,
      PostCategoryAddApiArg
    >({
      query: (queryArg) => ({
        url: `/Category/Add`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putCategoryUpdate: build.mutation<
      PutCategoryUpdateApiResponse,
      PutCategoryUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/Category/Update`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getCategoryListingPricesById: build.query<
      GetCategoryListingPricesByIdApiResponse,
      GetCategoryListingPricesByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Category/ListingPrices/${queryArg.id}`,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postCategoryUploadById: build.mutation<
      PostCategoryUploadByIdApiResponse,
      PostCategoryUploadByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Category/Upload/${queryArg.id}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteCategoryDeleteById: build.mutation<
      DeleteCategoryDeleteByIdApiResponse,
      DeleteCategoryDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Category/Delete/${queryArg}`,
        method: "DELETE",
      }),
    }),
    getContactGetListById: build.query<
      GetContactGetListByIdApiResponse,
      GetContactGetListByIdApiArg
    >({
      query: (queryArg) => ({ url: `/Contact/GetList/${queryArg}` }),
    }),
    getContactGetList: build.query<
      GetContactGetListApiResponse,
      GetContactGetListApiArg
    >({
      query: () => ({ url: `/Contact/GetList` }),
    }),
    postContactAdd: build.mutation<
      PostContactAddApiResponse,
      PostContactAddApiArg
    >({
      query: (queryArg) => ({
        url: `/Contact/Add`,
        method: "POST",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    deleteContactDeleteById: build.mutation<
      DeleteContactDeleteByIdApiResponse,
      DeleteContactDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Contact/Delete/${queryArg}`,
        method: "DELETE",
      }),
    }),
    getConversationByConversationIdHistory: build.query<
      GetConversationByConversationIdHistoryApiResponse,
      GetConversationByConversationIdHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/Conversation/${queryArg.conversationId}/History`,
        headers: {
          authorization: queryArg.authorization,
          "X-localization": queryArg["X-localization"],
        },
        params: {
          targetLang: queryArg.targetLang,
          translateMode: queryArg.translateMode,
        },
      }),
    }),
    getConversationUnreadCount: build.query<
      GetConversationUnreadCountApiResponse,
      GetConversationUnreadCountApiArg
    >({
      query: (queryArg) => ({
        url: `/Conversation/UnreadCount`,
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    getConversationGetList: build.query<
      GetConversationGetListApiResponse,
      GetConversationGetListApiArg
    >({
      query: (queryArg) => ({
        url: `/Conversation/GetList`,
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    getDocsOpenApi: build.query<
      GetDocsOpenApiApiResponse,
      GetDocsOpenApiApiArg
    >({
      query: () => ({ url: `/Docs/open-api` }),
    }),
    getFavoriteGet: build.query<
      GetFavoriteGetApiResponse,
      GetFavoriteGetApiArg
    >({
      query: (queryArg) => ({
        url: `/Favorite/Get`,
        headers: {
          authorization: queryArg.authorization,
          "X-localization": queryArg["X-localization"],
        },
      }),
    }),
    postFavoriteAdd: build.mutation<
      PostFavoriteAddApiResponse,
      PostFavoriteAddApiArg
    >({
      query: (queryArg) => ({
        url: `/Favorite/Add`,
        method: "POST",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getFeaturesGetList: build.query<
      GetFeaturesGetListApiResponse,
      GetFeaturesGetListApiArg
    >({
      query: (queryArg) => ({
        url: `/Features/GetList`,
        headers: {
          "X-localization": queryArg["X-localization"],
        },
        params: {
          category: queryArg.category,
          id: queryArg.id,
        },
      }),
    }),
    postFeaturesAdd: build.mutation<
      PostFeaturesAddApiResponse,
      PostFeaturesAddApiArg
    >({
      query: (queryArg) => ({
        url: `/Features/Add`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putFeaturesUpdate: build.mutation<
      PutFeaturesUpdateApiResponse,
      PutFeaturesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/Features/Update`,
        method: "PUT",
        body: queryArg,
      }),
    }),
    deleteFeaturesDeleteById: build.mutation<
      DeleteFeaturesDeleteByIdApiResponse,
      DeleteFeaturesDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Features/Delete/${queryArg}`,
        method: "DELETE",
      }),
    }),
    postKycStart: build.mutation<PostKycStartApiResponse, PostKycStartApiArg>({
      query: (queryArg) => ({
        url: `/Kyc/Start`,
        method: "POST",
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    getKycStatus: build.query<GetKycStatusApiResponse, GetKycStatusApiArg>({
      query: (queryArg) => ({
        url: `/Kyc/Status`,
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    postKycWebhook: build.mutation<
      PostKycWebhookApiResponse,
      PostKycWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/Kyc/Webhook`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "persona-signature": queryArg["persona-signature"],
        },
      }),
    }),
    getKycGetList: build.query<GetKycGetListApiResponse, GetKycGetListApiArg>({
      query: (queryArg) => ({
        url: `/Kyc/GetList`,
        headers: {
          authorization: queryArg.authorization,
        },
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          status: queryArg.status,
          search: queryArg.search,
        },
      }),
    }),
    getKycGetByIdByUserId: build.query<
      GetKycGetByIdByUserIdApiResponse,
      GetKycGetByIdByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Kyc/GetById/${queryArg.userId}`,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getKycHealth: build.query<GetKycHealthApiResponse, GetKycHealthApiArg>({
      query: (queryArg) => ({
        url: `/Kyc/Health`,
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    postKycUpdateStatus: build.mutation<
      PostKycUpdateStatusApiResponse,
      PostKycUpdateStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/Kyc/UpdateStatus`,
        method: "POST",
        body: queryArg.kycAdminUpdateStatusBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postKycSetPhoneVerified: build.mutation<
      PostKycSetPhoneVerifiedApiResponse,
      PostKycSetPhoneVerifiedApiArg
    >({
      query: (queryArg) => ({
        url: `/Kyc/SetPhoneVerified`,
        method: "POST",
        body: queryArg.kycAdminSetPhoneBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getPageGetListByPageno: build.query<
      GetPageGetListByPagenoApiResponse,
      GetPageGetListByPagenoApiArg
    >({
      query: (queryArg) => ({
        url: `/Page/GetList/${queryArg.pageno}`,
        headers: {
          "X-localization": queryArg["X-localization"],
          authorization: queryArg.authorization,
        },
      }),
    }),
    getPageGetList: build.query<
      GetPageGetListApiResponse,
      GetPageGetListApiArg
    >({
      query: (queryArg) => ({
        url: `/Page/GetList`,
        headers: {
          "X-localization": queryArg["X-localization"],
          authorization: queryArg.authorization,
        },
      }),
    }),
    putPageUpdate: build.mutation<
      PutPageUpdateApiResponse,
      PutPageUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/Page/Update`,
        method: "PUT",
        body: queryArg,
      }),
    }),
    postPasswordReset: build.mutation<
      PostPasswordResetApiResponse,
      PostPasswordResetApiArg
    >({
      query: (queryArg) => ({
        url: `/Password/Reset`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putPasswordReset: build.mutation<
      PutPasswordResetApiResponse,
      PutPasswordResetApiArg
    >({
      query: (queryArg) => ({
        url: `/Password/Reset`,
        method: "PUT",
        body: queryArg,
      }),
    }),
    postPasswordCode: build.mutation<
      PostPasswordCodeApiResponse,
      PostPasswordCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/Password/Code`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putPasswordChange: build.mutation<
      PutPasswordChangeApiResponse,
      PutPasswordChangeApiArg
    >({
      query: (queryArg) => ({
        url: `/Password/Change`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getPaymentPrice: build.query<
      GetPaymentPriceApiResponse,
      GetPaymentPriceApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Price`,
        headers: {
          authorization: queryArg.authorization,
        },
        params: {
          categoryId: queryArg.categoryId,
          currency: queryArg.currency,
        },
      }),
    }),
    postPaymentCreateForProductByProductId: build.mutation<
      PostPaymentCreateForProductByProductIdApiResponse,
      PostPaymentCreateForProductByProductIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/CreateForProduct/${queryArg.productId}`,
        method: "POST",
        body: queryArg.createPaymentBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getPaymentStatusByProductId: build.query<
      GetPaymentStatusByProductIdApiResponse,
      GetPaymentStatusByProductIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Status/${queryArg.productId}`,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getPaymentMy: build.query<GetPaymentMyApiResponse, GetPaymentMyApiArg>({
      query: (queryArg) => ({
        url: `/Payment/My`,
        headers: {
          authorization: queryArg.authorization,
        },
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          status: queryArg.status,
        },
      }),
    }),
    getPaymentGetList: build.query<
      GetPaymentGetListApiResponse,
      GetPaymentGetListApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/GetList`,
        headers: {
          authorization: queryArg.authorization,
        },
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          status: queryArg.status,
          search: queryArg.search,
          productId: queryArg.productId,
          userId: queryArg.userId,
          categoryId: queryArg.categoryId,
          from: queryArg["from"],
          to: queryArg.to,
          sort: queryArg.sort,
          order: queryArg.order,
        },
      }),
    }),
    getPaymentGetByIdById: build.query<
      GetPaymentGetByIdByIdApiResponse,
      GetPaymentGetByIdByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/GetById/${queryArg.id}`,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getPaymentSummary: build.query<
      GetPaymentSummaryApiResponse,
      GetPaymentSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Summary`,
        headers: {
          authorization: queryArg.authorization,
        },
        params: {
          from: queryArg["from"],
          to: queryArg.to,
          groupBy: queryArg.groupBy,
          categoryId: queryArg.categoryId,
        },
      }),
    }),
    getPaymentHealth: build.query<
      GetPaymentHealthApiResponse,
      GetPaymentHealthApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Health`,
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    getPaymentExport: build.query<
      GetPaymentExportApiResponse,
      GetPaymentExportApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Export`,
        headers: {
          authorization: queryArg.authorization,
        },
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          status: queryArg.status,
          search: queryArg.search,
          productId: queryArg.productId,
          userId: queryArg.userId,
          categoryId: queryArg.categoryId,
          from: queryArg["from"],
          to: queryArg.to,
          sort: queryArg.sort,
          order: queryArg.order,
        },
      }),
    }),
    postPaymentRefundById: build.mutation<
      PostPaymentRefundByIdApiResponse,
      PostPaymentRefundByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Refund/${queryArg.id}`,
        method: "POST",
        body: queryArg.paymentRefundBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postPaymentWaiveByProductId: build.mutation<
      PostPaymentWaiveByProductIdApiResponse,
      PostPaymentWaiveByProductIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Waive/${queryArg.productId}`,
        method: "POST",
        body: queryArg.paymentWaiveBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postPaymentWebhook: build.mutation<
      PostPaymentWebhookApiResponse,
      PostPaymentWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/Payment/Webhook`,
        method: "POST",
        headers: {
          "stripe-signature": queryArg,
        },
      }),
    }),
    postPhoneSendCode: build.mutation<
      PostPhoneSendCodeApiResponse,
      PostPhoneSendCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/Phone/SendCode`,
        method: "POST",
        body: queryArg.phoneCodeBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postPhoneVerify: build.mutation<
      PostPhoneVerifyApiResponse,
      PostPhoneVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/Phone/Verify`,
        method: "POST",
        body: queryArg.phoneVerifyBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getProductsGetListByStatus: build.query<
      GetProductsGetListByStatusApiResponse,
      GetProductsGetListByStatusApiArg
    >({
      query: (queryArg) => ({ url: `/Products/GetList/${queryArg}` }),
    }),
    getProductsSearch: build.query<
      GetProductsSearchApiResponse,
      GetProductsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Search`,
        headers: {
          "X-localization": queryArg["X-localization"],
        },
        params: {
          lat: queryArg.lat,
          lng: queryArg.lng,
          km: queryArg.km,
          size: queryArg.size,
          categoryId: queryArg.categoryId,
          rate: queryArg.rate,
          page: queryArg.page,
        },
      }),
    }),
    getProductsGeo: build.query<
      GetProductsGeoApiResponse,
      GetProductsGeoApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Geo`,
        headers: {
          "X-localization": queryArg["X-localization"],
        },
        params: {
          lat: queryArg.lat,
          lng: queryArg.lng,
          categoryId: queryArg.categoryId,
          km: queryArg.km,
          size: queryArg.size,
          page: queryArg.page,
          type: queryArg["type"],
        },
      }),
    }),
    getProductsGetByIdById: build.query<
      GetProductsGetByIdByIdApiResponse,
      GetProductsGetByIdByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/GetById/${queryArg.id}`,
        headers: {
          authorization: queryArg.authorization,
          "X-localization": queryArg["X-localization"],
        },
      }),
    }),
    getProductsGetByUserName: build.query<
      GetProductsGetByUserNameApiResponse,
      GetProductsGetByUserNameApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Get/${queryArg.userName}`,
        headers: {
          authorization: queryArg.authorization,
          "X-localization": queryArg["X-localization"],
        },
      }),
    }),
    getProductsGet: build.query<
      GetProductsGetApiResponse,
      GetProductsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Get`,
        headers: {
          authorization: queryArg.authorization,
          "X-localization": queryArg["X-localization"],
        },
      }),
    }),
    getProductsGetByDateByDate: build.query<
      GetProductsGetByDateByDateApiResponse,
      GetProductsGetByDateByDateApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/GetByDate/${queryArg.date}`,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getProductsPhoneById: build.query<
      GetProductsPhoneByIdApiResponse,
      GetProductsPhoneByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Phone/${queryArg.id}`,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getProductsPermissionByProductId: build.query<
      GetProductsPermissionByProductIdApiResponse,
      GetProductsPermissionByProductIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Permission/${queryArg.productId}`,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getProductsSyncData: build.query<
      GetProductsSyncDataApiResponse,
      GetProductsSyncDataApiArg
    >({
      query: () => ({ url: `/Products/SyncData` }),
    }),
    postProductsUploadById: build.mutation<
      PostProductsUploadByIdApiResponse,
      PostProductsUploadByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Upload/${queryArg.id}`,
        method: "POST",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postProductsTranslateProduct: build.mutation<
      PostProductsTranslateProductApiResponse,
      PostProductsTranslateProductApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/TranslateProduct`,
        method: "POST",
        body: queryArg.translateProductBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postProductsAdd: build.mutation<
      PostProductsAddApiResponse,
      PostProductsAddApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Add`,
        method: "POST",
        body: queryArg.productCreateBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postProductsAddNewService: build.mutation<
      PostProductsAddNewServiceApiResponse,
      PostProductsAddNewServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/AddNewService`,
        method: "POST",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    putProductsUpdateById: build.mutation<
      PutProductsUpdateByIdApiResponse,
      PutProductsUpdateByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Update/${queryArg.id}`,
        method: "PUT",
        body: queryArg.productUpdateBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    putProductsUpdateNewServiceById: build.mutation<
      PutProductsUpdateNewServiceByIdApiResponse,
      PutProductsUpdateNewServiceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/UpdateNewService/${queryArg.pathId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProductsDeleteById: build.mutation<
      DeleteProductsDeleteByIdApiResponse,
      DeleteProductsDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/Delete/${queryArg.id}`,
        method: "DELETE",
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    deleteProductsAdminDeleteById: build.mutation<
      DeleteProductsAdminDeleteByIdApiResponse,
      DeleteProductsAdminDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Products/AdminDelete/${queryArg.id}`,
        method: "DELETE",
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getReviewsGetById: build.query<
      GetReviewsGetByIdApiResponse,
      GetReviewsGetByIdApiArg
    >({
      query: (queryArg) => ({ url: `/Reviews/Get/${queryArg}` }),
    }),
    getReviewsGetRateByIdAndRate: build.query<
      GetReviewsGetRateByIdAndRateApiResponse,
      GetReviewsGetRateByIdAndRateApiArg
    >({
      query: (queryArg) => ({
        url: `/Reviews/GetRate/${queryArg.id}/${queryArg.rate}`,
      }),
    }),
    postReviewsAdd: build.mutation<
      PostReviewsAddApiResponse,
      PostReviewsAddApiArg
    >({
      query: (queryArg) => ({
        url: `/Reviews/Add`,
        method: "POST",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    deleteReviewsDeleteById: build.mutation<
      DeleteReviewsDeleteByIdApiResponse,
      DeleteReviewsDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Reviews/Delete/${queryArg.id}`,
        method: "DELETE",
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getRoleGetListById: build.query<
      GetRoleGetListByIdApiResponse,
      GetRoleGetListByIdApiArg
    >({
      query: (queryArg) => ({ url: `/Role/GetList/${queryArg}` }),
    }),
    getRoleGetList: build.query<
      GetRoleGetListApiResponse,
      GetRoleGetListApiArg
    >({
      query: () => ({ url: `/Role/GetList` }),
    }),
    postRoleAdd: build.mutation<PostRoleAddApiResponse, PostRoleAddApiArg>({
      query: (queryArg) => ({
        url: `/Role/Add`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putRoleUpdate: build.mutation<
      PutRoleUpdateApiResponse,
      PutRoleUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/Role/Update`,
        method: "PUT",
        body: queryArg,
      }),
    }),
    deleteRoleDeleteById: build.mutation<
      DeleteRoleDeleteByIdApiResponse,
      DeleteRoleDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/Role/Delete/${queryArg}`,
        method: "DELETE",
      }),
    }),
    getSettingGet: build.query<GetSettingGetApiResponse, GetSettingGetApiArg>({
      query: () => ({ url: `/Setting/Get` }),
    }),
    putSettingUpdate: build.mutation<
      PutSettingUpdateApiResponse,
      PutSettingUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/Setting/Update`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getSettingListingFeePrices: build.query<
      GetSettingListingFeePricesApiResponse,
      GetSettingListingFeePricesApiArg
    >({
      query: (queryArg) => ({
        url: `/Setting/ListingFeePrices`,
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    putSettingListingFeePrices: build.mutation<
      PutSettingListingFeePricesApiResponse,
      PutSettingListingFeePricesApiArg
    >({
      query: (queryArg) => ({
        url: `/Setting/ListingFeePrices`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    getStatisticsGetDashboard: build.query<
      GetStatisticsGetDashboardApiResponse,
      GetStatisticsGetDashboardApiArg
    >({
      query: () => ({ url: `/Statistics/GetDashboard` }),
    }),
    getStatisticsGetLog: build.query<
      GetStatisticsGetLogApiResponse,
      GetStatisticsGetLogApiArg
    >({
      query: () => ({ url: `/Statistics/GetLog` }),
    }),
    getUserGetList: build.query<
      GetUserGetListApiResponse,
      GetUserGetListApiArg
    >({
      query: (queryArg) => ({
        url: `/User/GetList`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          kycStatus: queryArg.kycStatus,
          verificationLevel: queryArg.verificationLevel,
          search: queryArg.search,
        },
      }),
    }),
    getUserGet: build.query<GetUserGetApiResponse, GetUserGetApiArg>({
      query: (queryArg) => ({
        url: `/User/Get`,
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    getUserGetByIdById: build.query<
      GetUserGetByIdByIdApiResponse,
      GetUserGetByIdByIdApiArg
    >({
      query: (queryArg) => ({ url: `/User/GetById/${queryArg}` }),
    }),
    getUserGetByUserNameByUserName: build.query<
      GetUserGetByUserNameByUserNameApiResponse,
      GetUserGetByUserNameByUserNameApiArg
    >({
      query: (queryArg) => ({ url: `/User/GetByUserName/${queryArg}` }),
    }),
    getUserCurrencies: build.query<
      GetUserCurrenciesApiResponse,
      GetUserCurrenciesApiArg
    >({
      query: () => ({ url: `/User/Currencies` }),
    }),
    putUserUpdate: build.mutation<
      PutUserUpdateApiResponse,
      PutUserUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/User/Update`,
        method: "PUT",
        body: queryArg.userUpdateDto,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postUserSetActive: build.mutation<
      PostUserSetActiveApiResponse,
      PostUserSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/User/SetActive`,
        method: "POST",
        body: queryArg.adminSetActiveBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postUserSetRole: build.mutation<
      PostUserSetRoleApiResponse,
      PostUserSetRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/User/SetRole`,
        method: "POST",
        body: queryArg.adminSetRoleBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    putUserUpdateByIdById: build.mutation<
      PutUserUpdateByIdByIdApiResponse,
      PutUserUpdateByIdByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/User/UpdateById/${queryArg.id}`,
        method: "PUT",
        body: queryArg.userUpdateDto,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    putUserChangeLanguage: build.mutation<
      PutUserChangeLanguageApiResponse,
      PutUserChangeLanguageApiArg
    >({
      query: (queryArg) => ({
        url: `/User/ChangeLanguage`,
        method: "PUT",
        body: queryArg.changeLanguageBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postUserUploadById: build.mutation<
      PostUserUploadByIdApiResponse,
      PostUserUploadByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/User/Upload/${queryArg.id}`,
        method: "POST",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postUserRegister: build.mutation<
      PostUserRegisterApiResponse,
      PostUserRegisterApiArg
    >({
      query: (queryArg) => ({
        url: `/User/Register`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postUserSocialLogin: build.mutation<
      PostUserSocialLoginApiResponse,
      PostUserSocialLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/User/SocialLogin`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postUserLogin: build.mutation<
      PostUserLoginApiResponse,
      PostUserLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/User/Login`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postUserLoginVerify: build.mutation<
      PostUserLoginVerifyApiResponse,
      PostUserLoginVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/User/LoginVerify`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postUserLoginResend: build.mutation<
      PostUserLoginResendApiResponse,
      PostUserLoginResendApiArg
    >({
      query: (queryArg) => ({
        url: `/User/LoginResend`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putUserTwoFactor: build.mutation<
      PutUserTwoFactorApiResponse,
      PutUserTwoFactorApiArg
    >({
      query: (queryArg) => ({
        url: `/User/TwoFactor`,
        method: "PUT",
        body: queryArg.twoFactorBody,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
    postUserGuestUser: build.mutation<
      PostUserGuestUserApiResponse,
      PostUserGuestUserApiArg
    >({
      query: (queryArg) => ({
        url: `/User/GuestUser`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postUserLogout: build.mutation<
      PostUserLogoutApiResponse,
      PostUserLogoutApiArg
    >({
      query: (queryArg) => ({
        url: `/User/Logout`,
        method: "POST",
        headers: {
          authorization: queryArg,
        },
      }),
    }),
    postUserDeleteRequest: build.mutation<
      PostUserDeleteRequestApiResponse,
      PostUserDeleteRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/User/DeleteRequest`,
        method: "POST",
        body: queryArg.body,
        headers: {
          authorization: queryArg.authorization,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as kiralasakApi };
export type GetCategoryGetListByIdApiResponse =
  /** status 200  */ CategoryApiResult;
export type GetCategoryGetListByIdApiArg = {
  "X-localization"?: string;
  authorization?: string;
  id: string;
  type?: string;
};
export type GetCategoryGetListApiResponse =
  /** status 200  */ CategoryApiResult;
export type GetCategoryGetListApiArg = {
  "X-localization"?: string;
  authorization?: string;
  type?: string;
};
export type PostCategoryAddApiResponse =
  /** status 200 Successful response */ Blob;
export type PostCategoryAddApiArg = any;
export type PutCategoryUpdateApiResponse =
  /** status 200 Successful response */ Blob;
export type PutCategoryUpdateApiArg = {
  authorization?: string;
  body: any;
};
export type GetCategoryListingPricesByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type GetCategoryListingPricesByIdApiArg = {
  authorization?: string;
  id: string;
};
export type PostCategoryUploadByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type PostCategoryUploadByIdApiArg = {
  id: string;
  body: any;
};
export type DeleteCategoryDeleteByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type DeleteCategoryDeleteByIdApiArg = string;
export type GetContactGetListByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type GetContactGetListByIdApiArg = string;
export type GetContactGetListApiResponse =
  /** status 200 Successful response */ Blob;
export type GetContactGetListApiArg = void;
export type PostContactAddApiResponse =
  /** status 200 Successful response */ Blob;
export type PostContactAddApiArg = {
  authorization?: string;
  body: any;
};
export type DeleteContactDeleteByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type DeleteContactDeleteByIdApiArg = string;
export type GetConversationByConversationIdHistoryApiResponse =
  /** status 200  */ ConversationApiResult;
export type GetConversationByConversationIdHistoryApiArg = {
  authorization?: string;
  "X-localization"?: string;
  conversationId: string;
  targetLang?: string;
  translateMode?: boolean;
};
export type GetConversationUnreadCountApiResponse =
  /** status 200  */ ConversationUnreadCountApiResult;
export type GetConversationUnreadCountApiArg = string | undefined;
export type GetConversationGetListApiResponse =
  /** status 200 Successful response */ Blob;
export type GetConversationGetListApiArg = string | undefined;
export type GetDocsOpenApiApiResponse =
  /** status 200 Successful response */ Blob;
export type GetDocsOpenApiApiArg = void;
export type GetFavoriteGetApiResponse =
  /** status 200 Successful response */ Blob;
export type GetFavoriteGetApiArg = {
  authorization?: string;
  "X-localization"?: string;
};
export type PostFavoriteAddApiResponse =
  /** status 200 Successful response */ Blob;
export type PostFavoriteAddApiArg = {
  authorization?: string;
  body: any;
};
export type GetFeaturesGetListApiResponse =
  /** status 200  */ FeaturesApiResult;
export type GetFeaturesGetListApiArg = {
  "X-localization"?: string;
  category?: string;
  id?: string;
};
export type PostFeaturesAddApiResponse =
  /** status 200 Successful response */ Blob;
export type PostFeaturesAddApiArg =
  /** FeaturesCreateBody */ FeaturesCreateBody;
export type PutFeaturesUpdateApiResponse =
  /** status 200 Successful response */ Blob;
export type PutFeaturesUpdateApiArg =
  /** FeaturesCreateBody */ FeaturesCreateBody;
export type DeleteFeaturesDeleteByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type DeleteFeaturesDeleteByIdApiArg = string;
export type PostKycStartApiResponse = /** status 200  */ KycStartApiResult;
export type PostKycStartApiArg = string | undefined;
export type GetKycStatusApiResponse = /** status 200  */ KycStatusApiResult;
export type GetKycStatusApiArg = string | undefined;
export type PostKycWebhookApiResponse =
  /** status 200 Successful response */ Blob;
export type PostKycWebhookApiArg = {
  "persona-signature"?: string;
  body: any;
};
export type GetKycGetListApiResponse = /** status 200  */ KycAdminListApiResult;
export type GetKycGetListApiArg = {
  authorization?: string;
  page?: number;
  limit?: number;
  status?:
    | "not_started"
    | "pending"
    | "processing"
    | "approved"
    | "declined"
    | "needs_review"
    | "expired";
  search?: string;
};
export type GetKycGetByIdByUserIdApiResponse =
  /** status 200  */ KycAdminItemApiResult;
export type GetKycGetByIdByUserIdApiArg = {
  authorization?: string;
  userId: string;
};
export type GetKycHealthApiResponse = /** status 200  */ KycHealthApiResult;
export type GetKycHealthApiArg = string | undefined;
export type PostKycUpdateStatusApiResponse =
  /** status 200  */ KycAdminActionApiResult;
export type PostKycUpdateStatusApiArg = {
  authorization?: string;
  /** KycAdminUpdateStatusBody */
  kycAdminUpdateStatusBody: KycAdminUpdateStatusBody;
};
export type PostKycSetPhoneVerifiedApiResponse =
  /** status 200  */ KycAdminActionApiResult;
export type PostKycSetPhoneVerifiedApiArg = {
  authorization?: string;
  /** KycAdminSetPhoneBody */
  kycAdminSetPhoneBody: KycAdminSetPhoneBody;
};
export type GetPageGetListByPagenoApiResponse =
  /** status 200 Successful response */ Blob;
export type GetPageGetListByPagenoApiArg = {
  "X-localization"?: string;
  authorization?: string;
  pageno: string;
};
export type GetPageGetListApiResponse =
  /** status 200 Successful response */ Blob;
export type GetPageGetListApiArg = {
  "X-localization"?: string;
  authorization?: string;
};
export type PutPageUpdateApiResponse =
  /** status 200 Successful response */ Blob;
export type PutPageUpdateApiArg = any;
export type PostPasswordResetApiResponse =
  /** status 200 Successful response */ Blob;
export type PostPasswordResetApiArg = any;
export type PutPasswordResetApiResponse =
  /** status 200 Successful response */ Blob;
export type PutPasswordResetApiArg = any;
export type PostPasswordCodeApiResponse =
  /** status 200 Successful response */ Blob;
export type PostPasswordCodeApiArg = any;
export type PutPasswordChangeApiResponse =
  /** status 200 Successful response */ Blob;
export type PutPasswordChangeApiArg = {
  authorization?: string;
  body: any;
};
export type GetPaymentPriceApiResponse =
  /** status 200  */ ListingPriceApiResult;
export type GetPaymentPriceApiArg = {
  authorization?: string;
  categoryId: string;
  currency?: string;
};
export type PostPaymentCreateForProductByProductIdApiResponse =
  /** status 200  */ PaymentSessionApiResult;
export type PostPaymentCreateForProductByProductIdApiArg = {
  authorization?: string;
  productId: string;
  /** CreatePaymentBody */
  createPaymentBody: CreatePaymentBody;
};
export type GetPaymentStatusByProductIdApiResponse =
  /** status 200  */ PaymentStatusApiResult;
export type GetPaymentStatusByProductIdApiArg = {
  authorization?: string;
  productId: string;
};
export type GetPaymentMyApiResponse = /** status 200  */ MyPaymentListApiResult;
export type GetPaymentMyApiArg = {
  authorization?: string;
  page?: number;
  limit?: number;
  status?: string;
};
export type GetPaymentGetListApiResponse =
  /** status 200  */ PaymentAdminListApiResult;
export type GetPaymentGetListApiArg = {
  authorization?: string;
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  productId?: string;
  userId?: string;
  categoryId?: string;
  from?: string;
  to?: string;
  sort?: "createdAt" | "amount";
  order?: "asc" | "desc" | "ASC" | "DESC";
};
export type GetPaymentGetByIdByIdApiResponse =
  /** status 200  */ PaymentAdminItemApiResult;
export type GetPaymentGetByIdByIdApiArg = {
  authorization?: string;
  id: string;
};
export type GetPaymentSummaryApiResponse =
  /** status 200  */ PaymentSummaryApiResult;
export type GetPaymentSummaryApiArg = {
  authorization?: string;
  from?: string;
  to?: string;
  groupBy?: "day" | "week" | "month";
  categoryId?: string;
};
export type GetPaymentHealthApiResponse =
  /** status 200  */ PaymentHealthApiResult;
export type GetPaymentHealthApiArg = string | undefined;
export type GetPaymentExportApiResponse =
  /** status 200 Successful response */ Blob;
export type GetPaymentExportApiArg = {
  authorization?: string;
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  productId?: string;
  userId?: string;
  categoryId?: string;
  from?: string;
  to?: string;
  sort?: "createdAt" | "amount";
  order?: "asc" | "desc" | "ASC" | "DESC";
};
export type PostPaymentRefundByIdApiResponse =
  /** status 200  */ PaymentAdminItemApiResult;
export type PostPaymentRefundByIdApiArg = {
  authorization?: string;
  id: string;
  /** PaymentRefundBody */
  paymentRefundBody: PaymentRefundBody;
};
export type PostPaymentWaiveByProductIdApiResponse =
  /** status 200  */ PaymentStatusApiResult;
export type PostPaymentWaiveByProductIdApiArg = {
  authorization?: string;
  productId: string;
  /** PaymentWaiveBody */
  paymentWaiveBody: PaymentWaiveBody;
};
export type PostPaymentWebhookApiResponse =
  /** status 200 Successful response */ Blob;
export type PostPaymentWebhookApiArg = string | undefined;
export type PostPhoneSendCodeApiResponse =
  /** status 200  */ PhoneCodeApiResult;
export type PostPhoneSendCodeApiArg = {
  authorization?: string;
  /** PhoneCodeBody */
  phoneCodeBody: PhoneCodeBody;
};
export type PostPhoneVerifyApiResponse =
  /** status 200  */ PhoneVerifyApiResult;
export type PostPhoneVerifyApiArg = {
  authorization?: string;
  /** PhoneVerifyBody */
  phoneVerifyBody: PhoneVerifyBody;
};
export type GetProductsGetListByStatusApiResponse =
  /** status 200  */ ProductsApiResult;
export type GetProductsGetListByStatusApiArg = string;
export type GetProductsSearchApiResponse = /** status 200  */ ProductsApiResult;
export type GetProductsSearchApiArg = {
  "X-localization"?: string;
  lat: string;
  lng: string;
  km?: number;
  size?: number;
  categoryId?: string;
  rate?: number;
  page?: number;
};
export type GetProductsGeoApiResponse = /** status 200  */ ProductsApiResult;
export type GetProductsGeoApiArg = {
  "X-localization"?: string;
  lat: string;
  lng: string;
  categoryId?: string;
  km?: number;
  size?: number;
  page?: number;
  type?: number;
};
export type GetProductsGetByIdByIdApiResponse =
  /** status 200  */ ProductApiResult;
export type GetProductsGetByIdByIdApiArg = {
  authorization?: string;
  "X-localization"?: string;
  id: string;
};
export type GetProductsGetByUserNameApiResponse =
  /** status 200  */ ProductApiResult;
export type GetProductsGetByUserNameApiArg = {
  authorization?: string;
  "X-localization"?: string;
  userName: string;
};
export type GetProductsGetApiResponse = /** status 200  */ ProductApiResult;
export type GetProductsGetApiArg = {
  authorization?: string;
  "X-localization"?: string;
};
export type GetProductsGetByDateByDateApiResponse =
  /** status 200  */ ProductsApiResult;
export type GetProductsGetByDateByDateApiArg = {
  authorization?: string;
  date: string;
};
export type GetProductsPhoneByIdApiResponse =
  /** status 200  */ ProductPhoneApiResult;
export type GetProductsPhoneByIdApiArg = {
  authorization?: string;
  id: string;
};
export type GetProductsPermissionByProductIdApiResponse =
  /** status 200  */ ProductsApiResult;
export type GetProductsPermissionByProductIdApiArg = {
  authorization?: string;
  productId: string;
};
export type GetProductsSyncDataApiResponse =
  /** status 200  */ ProductApiResult;
export type GetProductsSyncDataApiArg = void;
export type PostProductsUploadByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type PostProductsUploadByIdApiArg = {
  authorization?: string;
  id: string;
  body: any;
};
export type PostProductsTranslateProductApiResponse =
  /** status 200  */ TranslateApiResult;
export type PostProductsTranslateProductApiArg = {
  authorization?: string;
  /** TranslateProductBody */
  translateProductBody: TranslateProductBody;
};
export type PostProductsAddApiResponse = /** status 200  */ ProductApiResult;
export type PostProductsAddApiArg = {
  authorization?: string;
  /** ProductCreateBody */
  productCreateBody: ProductCreateBody;
};
export type PostProductsAddNewServiceApiResponse =
  /** status 200  */ ProductApiResult;
export type PostProductsAddNewServiceApiArg = {
  authorization?: string;
  body: object;
};
export type PutProductsUpdateByIdApiResponse =
  /** status 200  */ ProductApiResult;
export type PutProductsUpdateByIdApiArg = {
  authorization?: string;
  id: string;
  /** ProductUpdateBody */
  productUpdateBody: ProductUpdateBody;
};
export type PutProductsUpdateNewServiceByIdApiResponse =
  /** status 200  */ ProductApiResult;
export type PutProductsUpdateNewServiceByIdApiArg = {
  /** Product ID to update */
  pathId: string;
  _pathId: string;
  body: {
    /** Product title (optional) */
    title?: string;
    /** Product description (optional) */
    description?: string;
    /** Category UUID (optional) */
    category_id?: string;
    /** Longitude coordinate (optional) */
    longitude?: string;
    /** Latitude coordinate (optional) */
    latitude?: string;
    /** Location address (optional) */
    location_string?: string;
    /** Phone type to use (optional) */
    phoneType?: "NEW_PHONE" | "USER_PHONE";
    /** Phone number (optional) */
    phone?: string;
    /** Currency code (optional) */
    currency_code?: string;
    /** JSON string of price array (optional) */
    prices?: string;
    /** JSON string of features array (optional) */
    features?: string;
    /** Detailed address (optional) */
    address?: string;
    /** Product active status (optional, admin only) */
    active?: "true" | "false";
    /** Product status (optional, admin only) */
    status?: string;
    /** Which image should be poster (1-10) - REQUIRED */
    poster: string;
    /** Product images (1-10 files, max 10MB each) - REQUIRED, represents final state */
    images: Blob[];
  };
};
export type DeleteProductsDeleteByIdApiResponse =
  /** status 200  */ ProductApiResult;
export type DeleteProductsDeleteByIdApiArg = {
  authorization?: string;
  id: string;
};
export type DeleteProductsAdminDeleteByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type DeleteProductsAdminDeleteByIdApiArg = {
  authorization?: string;
  id: string;
};
export type GetReviewsGetByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type GetReviewsGetByIdApiArg = string;
export type GetReviewsGetRateByIdAndRateApiResponse =
  /** status 200 Successful response */ Blob;
export type GetReviewsGetRateByIdAndRateApiArg = {
  id: string;
  rate: string;
};
export type PostReviewsAddApiResponse =
  /** status 200 Successful response */ Blob;
export type PostReviewsAddApiArg = {
  authorization?: string;
  body: any;
};
export type DeleteReviewsDeleteByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type DeleteReviewsDeleteByIdApiArg = {
  authorization?: string;
  id: string;
};
export type GetRoleGetListByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type GetRoleGetListByIdApiArg = string;
export type GetRoleGetListApiResponse =
  /** status 200 Successful response */ Blob;
export type GetRoleGetListApiArg = void;
export type PostRoleAddApiResponse = /** status 200 Successful response */ Blob;
export type PostRoleAddApiArg = any;
export type PutRoleUpdateApiResponse =
  /** status 200 Successful response */ Blob;
export type PutRoleUpdateApiArg = any;
export type DeleteRoleDeleteByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type DeleteRoleDeleteByIdApiArg = string;
export type GetSettingGetApiResponse =
  /** status 200 Successful response */ Blob;
export type GetSettingGetApiArg = void;
export type PutSettingUpdateApiResponse =
  /** status 200 Successful response */ Blob;
export type PutSettingUpdateApiArg = {
  authorization?: string;
  body: any;
};
export type GetSettingListingFeePricesApiResponse =
  /** status 200 Successful response */ Blob;
export type GetSettingListingFeePricesApiArg = string | undefined;
export type PutSettingListingFeePricesApiResponse =
  /** status 200 Successful response */ Blob;
export type PutSettingListingFeePricesApiArg = {
  authorization?: string;
  body: any;
};
export type GetStatisticsGetDashboardApiResponse =
  /** status 200  */ DashboardStatisticsApiResult;
export type GetStatisticsGetDashboardApiArg = void;
export type GetStatisticsGetLogApiResponse = /** status 200  */ GetLogApiResult;
export type GetStatisticsGetLogApiArg = void;
export type GetUserGetListApiResponse = /** status 200  */ GetListUserApiResult;
export type GetUserGetListApiArg = {
  page?: number;
  limit?: number;
  kycStatus?: string;
  verificationLevel?: string;
  search?: string;
};
export type GetUserGetApiResponse = /** status 200  */ GetUserApiResult;
export type GetUserGetApiArg = string | undefined;
export type GetUserGetByIdByIdApiResponse =
  /** status 200  */ GetPublicUserApiResult;
export type GetUserGetByIdByIdApiArg = string;
export type GetUserGetByUserNameByUserNameApiResponse =
  /** status 200  */ GetPublicUserApiResult;
export type GetUserGetByUserNameByUserNameApiArg = string;
export type GetUserCurrenciesApiResponse =
  /** status 200  */ GetCurrencyApiResult;
export type GetUserCurrenciesApiArg = void;
export type PutUserUpdateApiResponse = /** status 200  */ UpdateUserApiResult;
export type PutUserUpdateApiArg = {
  authorization?: string;
  /** UserUpdateDto */
  userUpdateDto: UserUpdateDto;
};
export type PostUserSetActiveApiResponse =
  /** status 200  */ AdminSetActiveApiResult;
export type PostUserSetActiveApiArg = {
  authorization?: string;
  /** AdminSetActiveBody */
  adminSetActiveBody: AdminSetActiveBody;
};
export type PostUserSetRoleApiResponse =
  /** status 200  */ AdminSetRoleApiResult;
export type PostUserSetRoleApiArg = {
  authorization?: string;
  /** AdminSetRoleBody */
  adminSetRoleBody: AdminSetRoleBody;
};
export type PutUserUpdateByIdByIdApiResponse =
  /** status 200  */ UpdateUserApiResult;
export type PutUserUpdateByIdByIdApiArg = {
  authorization?: string;
  id: string;
  /** UserUpdateDto */
  userUpdateDto: UserUpdateDto;
};
export type PutUserChangeLanguageApiResponse =
  /** status 200  */ UpdateUserApiResult;
export type PutUserChangeLanguageApiArg = {
  authorization?: string;
  /** ChangeLanguageBody */
  changeLanguageBody: ChangeLanguageBody;
};
export type PostUserUploadByIdApiResponse =
  /** status 200 Successful response */ Blob;
export type PostUserUploadByIdApiArg = {
  authorization?: string;
  id: string;
  body: any;
};
export type PostUserRegisterApiResponse = /** status 200  */ RegisterApiResult;
export type PostUserRegisterApiArg = /** RegisterBodyDto */ RegisterBodyDto;
export type PostUserSocialLoginApiResponse =
  /** status 200  */ LoginResultApiResult;
export type PostUserSocialLoginApiArg = /** SocialLoginDto */ SocialLoginDto;
export type PostUserLoginApiResponse = /** status 200  */ LoginResultApiResult;
export type PostUserLoginApiArg = any;
export type PostUserLoginVerifyApiResponse = /** status 200  */ LoginApiResult;
export type PostUserLoginVerifyApiArg = /** LoginVerifyBody */ LoginVerifyBody;
export type PostUserLoginResendApiResponse =
  /** status 200  */ PhoneCodeApiResult;
export type PostUserLoginResendApiArg = /** LoginResendBody */ LoginResendBody;
export type PutUserTwoFactorApiResponse = /** status 200  */ TwoFactorApiResult;
export type PutUserTwoFactorApiArg = {
  authorization?: string;
  /** TwoFactorBody */
  twoFactorBody: TwoFactorBody;
};
export type PostUserGuestUserApiResponse =
  /** status 200  */ GuestUserLoginApiResult;
export type PostUserGuestUserApiArg = /** GuestUserBodyDto */ GuestUserBodyDto;
export type PostUserLogoutApiResponse =
  /** status 200 Successful response */ Blob;
export type PostUserLogoutApiArg = string | undefined;
export type PostUserDeleteRequestApiResponse =
  /** status 200 Successful response */ Blob;
export type PostUserDeleteRequestApiArg = {
  authorization?: string;
  body: any;
};
export type CategoryImageDto = {
  image: string;
};
export type CategoryDto = {
  id: string;
  mainId: string;
  title: string;
  order: number;
  color: string;
  icon: string;
  description: string;
  created_at: string;
  subCategoryCount: number;
  poster: string;
  images: CategoryImageDto;
};
export type CategoryApiResult = {
  data: CategoryDto[];
  code: string;
  isSuccess: boolean;
  message: string;
};
export type Product = {
  id: string;
  title: string;
  poster: string;
  isActive: boolean;
  status: number;
  sallerName: string;
  sallerSurname: string;
};
export type TranslationInfo = {
  sourceLang: string;
  targetLang: string;
  confidence?: number;
  isFromCache: boolean;
};
export type Sender = {
  id: string;
};
export type SenderInfo = {
  id: string;
  name: string;
  surname: string;
  userName: string;
  avatar: string;
};
export type Message = {
  id: string;
  content: string;
  detectedLanguage?: string;
  translatedContent?: string;
  translationInfo?: TranslationInfo;
  createdAt: string;
  isRead: boolean;
  isEdited: boolean;
  editedAt: string;
  senderId: string;
  sender: Sender;
  senderInfo: SenderInfo;
};
export type ConversationDto = {
  id: string;
  product: Product;
  messages: Message[];
};
export type ConversationApiResult = {
  data: ConversationDto;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type ConversationUnreadCountDto = {
  count: number;
};
export type ConversationUnreadCountApiResult = {
  data: ConversationUnreadCountDto;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type FeatureDto = {
  id: string;
  title: string;
  icon: string;
  active: boolean;
  created_at: string;
  categories: CategoryDto;
};
export type FeaturesApiResult = {
  data: FeatureDto;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type FeaturesCreateBody = {
  id?: string;
  title: string;
  icon: string;
  languages?: any;
  categories: any[];
};
export type KycStartData = {
  inquiryId: string;
  sessionToken?: string;
  oneTimeLink?: string;
  status: string;
  reused?: boolean;
};
export type KycStartApiResult = {
  data: KycStartData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type KycBillingInfo = {
  currencyCode: string;
  country?: string;
  source: string;
};
export type KycStatusData = {
  status: string;
  verificationLevel: string;
  isVerified: boolean;
  canCreateListing: boolean;
  nameLocked: boolean;
  billing: KycBillingInfo;
};
export type KycStatusApiResult = {
  data: KycStatusData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type KycAdminItem = {
  userId: string;
  name: string;
  surname: string;
  userName?: string;
  email: string;
  phone?: string;
  phoneVerified: boolean;
  kycStatus: string;
  verificationLevel: string;
  isVerified: boolean;
  providerStatus?: string;
  attempts: number;
  declineReason?: string;
  decisionAt?: string;
  identitySyncedAt?: string;
  documentCountry?: string;
  billingCurrency?: string;
  manualOverride: boolean;
  updatedAt?: string;
};
export type KycAdminListMeta = {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};
export type KycAdminListData = {
  items: KycAdminItem[];
  meta: KycAdminListMeta;
};
export type KycAdminListApiResult = {
  data: KycAdminListData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type KycAdminUserInfo = {
  id: string;
  name: string;
  surname: string;
  userName?: string;
  email: string;
  phone?: string;
  phone_verified: boolean;
  active: boolean;
  created_at?: string;
};
export type KycAdminManualOverride = {
  by?: string;
  at?: string;
  note?: string;
};
export type KycAdminRecord = {
  provider: string;
  status: string;
  providerStatus?: string;
  attempts: number;
  declineReason?: string;
  decisionAt?: string;
  identitySyncedAt?: string;
  documentCountry?: string;
  inquiryId?: string;
  personaUrl?: string;
  manualOverride: KycAdminManualOverride;
  created_at?: string;
  updated_at?: string;
};
export type KycAdminItemData = {
  user: KycAdminUserInfo;
  verificationLevel: string;
  isVerified: boolean;
  canCreateListing: boolean;
  nameLocked: boolean;
  billing: KycBillingInfo;
  kyc?: KycAdminRecord;
};
export type KycAdminItemApiResult = {
  data: KycAdminItemData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type KycHealthIssue = {
  level: string;
  message: string;
};
export type KycHealthWebhook = {
  lastEventAt?: string;
  lastEventAgeHours?: number;
  eventsLast24h: number;
  invalidSignatures: number;
  lastInvalidSignatureAt?: string;
};
export type KycHealthPipeline = {
  totalRecords: number;
  stuckOver24h: number;
};
export type KycHealthConfig = {
  apiUrl: boolean;
  apiKey: boolean;
  templateId: boolean;
  webhookSecret: boolean;
  encryption: boolean;
  apiVersion?: string;
  environment?: string;
};
export type KycHealthData = {
  status: string;
  issues: KycHealthIssue[];
  webhook: KycHealthWebhook;
  pipeline: KycHealthPipeline;
  config: KycHealthConfig;
  checkedAt: string;
};
export type KycHealthApiResult = {
  data: KycHealthData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type KycAdminActionData = {
  userId: string;
  kycStatus: string;
  phone?: string;
  phoneVerified: boolean;
  verificationLevel: string;
  isVerified: boolean;
  canCreateListing: boolean;
  nameLocked: boolean;
};
export type KycAdminActionApiResult = {
  data: KycAdminActionData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type KycAdminUpdateStatusBody = {
  userId: string;
  status:
    | "not_started"
    | "pending"
    | "processing"
    | "approved"
    | "declined"
    | "needs_review"
    | "expired";
  note?: string;
};
export type KycAdminSetPhoneBody = {
  userId: string;
  phone_verified: boolean;
  phone?: string;
  note?: string;
};
export type ListingPriceData = {
  free: boolean;
  amount?: number;
  currencyCode?: string;
  billingCountry?: string;
  billingSource?: string;
};
export type ListingPriceApiResult = {
  data: ListingPriceData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PaymentSessionData = {
  paymentId: string;
  free: boolean;
  checkoutUrl?: string;
  clientSecret?: string;
  customerId?: string;
  ephemeralKey?: string;
  publishableKey?: string;
  amount?: number;
  currencyCode?: string;
};
export type PaymentSessionApiResult = {
  data: PaymentSessionData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type CreatePaymentBody = {
  platform: "web" | "ios" | "android";
  returnUrl?: string;
};
export type PaymentStatusData = {
  productId: string;
  productStatus: string;
  paymentStatus?: string;
  free: boolean;
};
export type PaymentStatusApiResult = {
  data: PaymentStatusData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type MyPaymentItem = {
  id: string;
  productId: string;
  productNo?: string;
  productTitle?: string;
  productStatus?: string;
  amount: number;
  currencyCode: string;
  refundedAmount: number;
  status: string;
  receiptUrl?: string;
  failureMessage?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type PaymentAdminListMeta = {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};
export type MyPaymentListData = {
  items: MyPaymentItem[];
  meta: PaymentAdminListMeta;
};
export type MyPaymentListApiResult = {
  data: MyPaymentListData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PaymentAdminItem = {
  id: string;
  productId: string;
  productNo?: string;
  productTitle?: string;
  userId: string;
  userEmail?: string;
  userName?: string;
  amount: number;
  currencyCode: string;
  status: string;
  attempts: number;
  baseAmount?: number;
  baseCurrencyCode?: string;
  fxRate?: number;
  refundedAmount: number;
  failureCode?: string;
  failureMessage?: string;
  receiptUrl?: string;
  paymentIntentId?: string;
  livemode?: boolean;
  providerReference?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type PaymentAdminListData = {
  items: PaymentAdminItem[];
  meta: PaymentAdminListMeta;
};
export type PaymentAdminListApiResult = {
  data: PaymentAdminListData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PaymentAdminItemApiResult = {
  data: PaymentAdminItem;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PaymentCurrencyTotal = {
  currencyCode: string;
  amount: number;
  count: number;
};
export type PaymentSummarySeriesItem = {
  period: string;
  currencyCode: string;
  amount: number;
  count: number;
};
export type PaymentSummaryData = {
  totals: PaymentCurrencyTotal[];
  refunded: PaymentCurrencyTotal[];
  series: PaymentSummarySeriesItem[];
};
export type PaymentSummaryApiResult = {
  data: PaymentSummaryData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PaymentHealthIssue = {
  level: string;
  message: string;
};
export type PaymentHealthWebhook = {
  lastEventAt?: string;
  lastEventAgeHours?: number;
  eventsLast24h: number;
};
export type PaymentHealthPipeline = {
  totalRecords: number;
  stuckProcessingOver1h: number;
  paidButStillPending: number;
};
export type PaymentHealthConfig = {
  secretKey: boolean;
  publishableKey: boolean;
  webhookSecret: boolean;
  returnUrl: boolean;
  returnOrigins: number;
  livemode: boolean;
};
export type PaymentHealthData = {
  status: string;
  issues: PaymentHealthIssue[];
  webhook: PaymentHealthWebhook;
  pipeline: PaymentHealthPipeline;
  config: PaymentHealthConfig;
  checkedAt?: string;
};
export type PaymentHealthApiResult = {
  data: PaymentHealthData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PaymentRefundBody = {
  amount?: number;
  reason?: string;
};
export type PaymentWaiveBody = {
  reason: string;
};
export type PhoneCodeData = {
  success: boolean;
  expiresInSeconds: number;
};
export type PhoneCodeApiResult = {
  data: PhoneCodeData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PhoneCodeBody = {
  phone?: string;
};
export type PhoneVerifyData = {
  success: boolean;
  verificationLevel: string;
  isVerified: boolean;
};
export type PhoneVerifyApiResult = {
  data: PhoneVerifyData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type PhoneVerifyBody = {
  code: string;
};
export type DetermineLanguageDto = {
  lang: string;
};
export type CurrencyDto = {
  id: string;
  name: string;
  code: string;
  symbol: string;
};
export type ProductPriceDto = {
  id?: string;
  priceType: string;
  price: string;
  pricePeriod?: number;
  pricePeriodType?: string;
  currency?: CurrencyDto;
  active?: boolean;
};
export type ProductFeatureDto = {
  id: string;
  categoryId: string;
  title: string;
  icon: string;
  active: boolean;
  created_at: string;
};
export type ProductCategoryDto = {
  icon: string;
  title: string;
};
export type ProductAuthorDto = {
  id: string;
  name: string;
  surname: string;
  userName: string;
  website: string;
  created_at: string;
  avatar: string;
};
export type ProductContactPhoneDto = {
  canView: boolean;
  reason: string;
};
export type ProductContactMessageDto = {
  canStart: boolean;
  reason: string;
};
export type ProductContactDto = {
  hasPhone: boolean;
  phone: ProductContactPhoneDto;
  message: ProductContactMessageDto;
};
export type ProductDto = {
  id: string;
  no: string;
  title: string;
  user_id: string;
  category_id: string;
  views: number;
  active: boolean;
  longitude: string;
  latitude: string;
  location_string: string;
  phone: string;
  website: string;
  description: string;
  status: number;
  forrent: string;
  forsale: string;
  is_favorite: boolean;
  current: string;
  determine?: DetermineLanguageDto;
  currency: CurrencyDto;
  address: string;
  created_at: string;
  updated_at: string;
  prices: ProductPriceDto[];
  presentationPrice: ProductPriceDto;
  averageReview: string;
  features: ProductFeatureDto[];
  poster: string;
  gallery: any[];
  category: ProductCategoryDto;
  author: ProductAuthorDto;
  contact: ProductContactDto;
};
export type ProductsApiResult = {
  data: ProductDto[];
  code: string;
  isSuccess: boolean;
  message: string;
};
export type ProductApiResult = {
  data: ProductDto;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type ProductPhoneDto = {
  phone: string;
  phoneType: string;
};
export type ProductPhoneApiResult = {
  data: ProductPhoneDto;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type TranslateProduct = {
  title: string;
  description: string;
};
export type TranslateApiResult = {
  data: TranslateProduct[];
  code: string;
  isSuccess: boolean;
  message: string;
};
export type TranslateProductBody = {
  product_code: string;
  source: string;
  target: string;
};
export type ProductPriceCreate = {
  id?: string;
  priceType: string;
  price: string;
  pricePeriod?: number;
  pricePeriodType?: string;
  currency: string;
  active?: boolean;
};
export type ProductCreateBody = {
  title: string;
  address: string;
  category_id: string;
  description: string;
  features: any[];
  latitude: number;
  longitude: number;
  location_string: string;
  phoneType: string;
  phone: string;
  currency_code: string;
  prices: ProductPriceCreate[];
};
export type ProductUpdateBody = {
  title?: string;
  address?: string;
  category_id?: string;
  description?: string;
  status?: number;
  rejectedSummary?: any;
  active?: boolean;
  features?: any[];
  latitude?: number;
  longitude?: number;
  location_string?: string;
  phoneType?: string;
  phone?: string;
  currency_code?: string;
  prices?: ProductPriceCreate[];
};
export type NumberOfLanguageDto = {
  label: string;
  value: number;
};
export type GetDashboardDto = {
  userCount: number;
  productCount: number;
  guestUserCount: number;
  contactMessageCount: number;
  numberOfLanguage: NumberOfLanguageDto;
};
export type DashboardStatisticsApiResult = {
  data: GetDashboardDto;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type GetLogDto = {
  log: string;
};
export type GetLogApiResult = {
  data: GetLogDto;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type AdminUserListItemDto = {
  id: string;
  name: string;
  surname: string;
  userName?: string;
  email: string;
  phone?: string;
  phone_verified: boolean;
  kyc_status: string;
  verificationLevel: string;
  isVerified: boolean;
  canCreateListing: boolean;
  role?: string;
  active: boolean;
  is_delete?: boolean;
  avatar?: string;
  created_at: string;
  updated_at: string;
};
export type AdminListMeta = {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};
export type AdminUserListData = {
  items: AdminUserListItemDto[];
  meta: AdminListMeta;
};
export type GetListUserApiResult = {
  data: AdminUserListData;
};
export type UserRoleDto = {
  title: string;
  type: number;
  product_count: number;
  month_price: number;
};
export type UserImage = {
  avatar: string;
};
export type UserKycDto = {
  status: string;
};
export type UserDto = {
  id: string;
  name: string;
  surname: string;
  userName: string;
  email: string;
  phone: string;
  phone_verified: boolean;
  two_factor_enabled: boolean;
  website?: string;
  language?: string;
  currency_code?: string;
  role: UserRoleDto;
  photos: UserImage;
  currency?: CurrencyDto;
  isContractApprove: boolean;
  active: boolean;
  is_delete: boolean;
  social_media?: string;
  isOnline?: boolean;
  verificationLevel: string;
  isVerified: boolean;
  canCreateListing: boolean;
  nameLocked: boolean;
  kyc: UserKycDto;
  created_at: string;
  updated_at: string;
};
export type GetUserApiResult = {
  data: UserDto;
};
export type PublicUserDto = {
  id: string;
  name: string;
  surname: string;
  userName: string;
  website?: string;
  language?: string;
  currency_code?: string;
  role: UserRoleDto;
  photos: UserImage;
  verificationLevel: string;
  isVerified: boolean;
  created_at: string;
};
export type GetPublicUserApiResult = {
  data: PublicUserDto;
};
export type GetCurrencyApiResult = {
  data: CurrencyDto[];
  code: string;
  isSuccess: boolean;
  message: string;
};
export type UserUpdateDto = {
  is_delete?: boolean;
  name: string;
  surname: string;
  email?: string;
  website?: string;
  phone?: string;
  currency_code?: string;
  role?: string;
  isContractApprove?: boolean;
  active?: boolean;
};
export type UpdateUserApiResult = {
  data: UserUpdateDto;
};
export type AdminSetActiveData = {
  userId: string;
  active: boolean;
  sessionsRevoked: boolean;
  affectedProducts: number;
};
export type AdminSetActiveApiResult = {
  data: AdminSetActiveData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type AdminSetActiveBody = {
  userId: string;
  active: boolean;
  reason?: string;
};
export type AdminSetRoleData = {
  userId: string;
  role: UserRoleDto;
  sessionsRevoked: boolean;
};
export type AdminSetRoleApiResult = {
  data: AdminSetRoleData;
  code: string;
  isSuccess: boolean;
  message: string;
};
export type AdminSetRoleBody = {
  userId: string;
  roleId: string;
  reason?: string;
};
export type ChangeLanguageBody = {
  language: string;
};
export type RegisterDto = {
  id: string;
  name: string;
  surname: string;
  userName: string;
  email: string;
  phone?: string;
  language?: string;
  currency_code?: string;
  isContractApprove: boolean;
  created_at: string;
};
export type RegisterApiResult = {
  data: RegisterDto;
};
export type RegisterBodyDto = {
  name: string;
  surname: string;
  email: string;
  isContractApprove: boolean;
  language: string;
  phone?: string;
  currency_code?: string;
  password: string;
  re_password: string;
};
export type LoginResultDto = {
  access_token?: string;
  expireDate?: string;
  expiresIn?: string;
  requiresTwoFactor?: boolean;
  challengeId?: string;
  maskedPhone?: string;
  expiresInSeconds?: number;
};
export type LoginResultApiResult = {
  data: LoginResultDto;
};
export type SocialLoginDto = {
  social_media: string;
  name: string;
  sur_name: string;
  id_token: string;
  photo?: string;
  locale?: string;
};
export type TokenDto = {
  access_token: string;
  expireDate: string;
  expiresIn: string;
};
export type LoginApiResult = {
  data: TokenDto;
};
export type LoginVerifyBody = {
  challengeId: string;
  code: string;
};
export type LoginResendBody = {
  challengeId: string;
};
export type TwoFactorDto = {
  two_factor_enabled: boolean;
};
export type TwoFactorApiResult = {
  data: TwoFactorDto;
};
export type TwoFactorBody = {
  enabled: boolean;
};
export type GuestUserLoginApiResult = {
  data: TokenDto;
};
export type GuestUserBodyDto = {
  device_id: string;
  platform: string;
  model_number: string;
};
export const {
  useGetCategoryGetListByIdQuery,
  useLazyGetCategoryGetListByIdQuery,
  useGetCategoryGetListQuery,
  useLazyGetCategoryGetListQuery,
  usePostCategoryAddMutation,
  usePutCategoryUpdateMutation,
  useGetCategoryListingPricesByIdQuery,
  useLazyGetCategoryListingPricesByIdQuery,
  usePostCategoryUploadByIdMutation,
  useDeleteCategoryDeleteByIdMutation,
  useGetContactGetListByIdQuery,
  useLazyGetContactGetListByIdQuery,
  useGetContactGetListQuery,
  useLazyGetContactGetListQuery,
  usePostContactAddMutation,
  useDeleteContactDeleteByIdMutation,
  useGetConversationByConversationIdHistoryQuery,
  useLazyGetConversationByConversationIdHistoryQuery,
  useGetConversationUnreadCountQuery,
  useLazyGetConversationUnreadCountQuery,
  useGetConversationGetListQuery,
  useLazyGetConversationGetListQuery,
  useGetDocsOpenApiQuery,
  useLazyGetDocsOpenApiQuery,
  useGetFavoriteGetQuery,
  useLazyGetFavoriteGetQuery,
  usePostFavoriteAddMutation,
  useGetFeaturesGetListQuery,
  useLazyGetFeaturesGetListQuery,
  usePostFeaturesAddMutation,
  usePutFeaturesUpdateMutation,
  useDeleteFeaturesDeleteByIdMutation,
  usePostKycStartMutation,
  useGetKycStatusQuery,
  useLazyGetKycStatusQuery,
  usePostKycWebhookMutation,
  useGetKycGetListQuery,
  useLazyGetKycGetListQuery,
  useGetKycGetByIdByUserIdQuery,
  useLazyGetKycGetByIdByUserIdQuery,
  useGetKycHealthQuery,
  useLazyGetKycHealthQuery,
  usePostKycUpdateStatusMutation,
  usePostKycSetPhoneVerifiedMutation,
  useGetPageGetListByPagenoQuery,
  useLazyGetPageGetListByPagenoQuery,
  useGetPageGetListQuery,
  useLazyGetPageGetListQuery,
  usePutPageUpdateMutation,
  usePostPasswordResetMutation,
  usePutPasswordResetMutation,
  usePostPasswordCodeMutation,
  usePutPasswordChangeMutation,
  useGetPaymentPriceQuery,
  useLazyGetPaymentPriceQuery,
  usePostPaymentCreateForProductByProductIdMutation,
  useGetPaymentStatusByProductIdQuery,
  useLazyGetPaymentStatusByProductIdQuery,
  useGetPaymentMyQuery,
  useLazyGetPaymentMyQuery,
  useGetPaymentGetListQuery,
  useLazyGetPaymentGetListQuery,
  useGetPaymentGetByIdByIdQuery,
  useLazyGetPaymentGetByIdByIdQuery,
  useGetPaymentSummaryQuery,
  useLazyGetPaymentSummaryQuery,
  useGetPaymentHealthQuery,
  useLazyGetPaymentHealthQuery,
  useGetPaymentExportQuery,
  useLazyGetPaymentExportQuery,
  usePostPaymentRefundByIdMutation,
  usePostPaymentWaiveByProductIdMutation,
  usePostPaymentWebhookMutation,
  usePostPhoneSendCodeMutation,
  usePostPhoneVerifyMutation,
  useGetProductsGetListByStatusQuery,
  useLazyGetProductsGetListByStatusQuery,
  useGetProductsSearchQuery,
  useLazyGetProductsSearchQuery,
  useGetProductsGeoQuery,
  useLazyGetProductsGeoQuery,
  useGetProductsGetByIdByIdQuery,
  useLazyGetProductsGetByIdByIdQuery,
  useGetProductsGetByUserNameQuery,
  useLazyGetProductsGetByUserNameQuery,
  useGetProductsGetQuery,
  useLazyGetProductsGetQuery,
  useGetProductsGetByDateByDateQuery,
  useLazyGetProductsGetByDateByDateQuery,
  useGetProductsPhoneByIdQuery,
  useLazyGetProductsPhoneByIdQuery,
  useGetProductsPermissionByProductIdQuery,
  useLazyGetProductsPermissionByProductIdQuery,
  useGetProductsSyncDataQuery,
  useLazyGetProductsSyncDataQuery,
  usePostProductsUploadByIdMutation,
  usePostProductsTranslateProductMutation,
  usePostProductsAddMutation,
  usePostProductsAddNewServiceMutation,
  usePutProductsUpdateByIdMutation,
  usePutProductsUpdateNewServiceByIdMutation,
  useDeleteProductsDeleteByIdMutation,
  useDeleteProductsAdminDeleteByIdMutation,
  useGetReviewsGetByIdQuery,
  useLazyGetReviewsGetByIdQuery,
  useGetReviewsGetRateByIdAndRateQuery,
  useLazyGetReviewsGetRateByIdAndRateQuery,
  usePostReviewsAddMutation,
  useDeleteReviewsDeleteByIdMutation,
  useGetRoleGetListByIdQuery,
  useLazyGetRoleGetListByIdQuery,
  useGetRoleGetListQuery,
  useLazyGetRoleGetListQuery,
  usePostRoleAddMutation,
  usePutRoleUpdateMutation,
  useDeleteRoleDeleteByIdMutation,
  useGetSettingGetQuery,
  useLazyGetSettingGetQuery,
  usePutSettingUpdateMutation,
  useGetSettingListingFeePricesQuery,
  useLazyGetSettingListingFeePricesQuery,
  usePutSettingListingFeePricesMutation,
  useGetStatisticsGetDashboardQuery,
  useLazyGetStatisticsGetDashboardQuery,
  useGetStatisticsGetLogQuery,
  useLazyGetStatisticsGetLogQuery,
  useGetUserGetListQuery,
  useLazyGetUserGetListQuery,
  useGetUserGetQuery,
  useLazyGetUserGetQuery,
  useGetUserGetByIdByIdQuery,
  useLazyGetUserGetByIdByIdQuery,
  useGetUserGetByUserNameByUserNameQuery,
  useLazyGetUserGetByUserNameByUserNameQuery,
  useGetUserCurrenciesQuery,
  useLazyGetUserCurrenciesQuery,
  usePutUserUpdateMutation,
  usePostUserSetActiveMutation,
  usePostUserSetRoleMutation,
  usePutUserUpdateByIdByIdMutation,
  usePutUserChangeLanguageMutation,
  usePostUserUploadByIdMutation,
  usePostUserRegisterMutation,
  usePostUserSocialLoginMutation,
  usePostUserLoginMutation,
  usePostUserLoginVerifyMutation,
  usePostUserLoginResendMutation,
  usePutUserTwoFactorMutation,
  usePostUserGuestUserMutation,
  usePostUserLogoutMutation,
  usePostUserDeleteRequestMutation,
} = injectedRtkApi;
